import { FC, useState } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text, IconButton, CaretDownIconSmall, PlusIcon } from '@frontend/design-system';
import { StreamConversation } from '../../../types';
import { AddButton } from '../../common';
import { ChatListItem } from '../chat-list-item/chat-list-item';
import {
  sectionStyle,
  containerStyle,
  chevronContainerStyle,
  titleStyle,
  caretStyle,
  caretTransition,
} from './chat-category.styles';

interface ChatCategoryProps {
  title: string;
  chats: StreamConversation[];
  addNewConversation?: {
    onClick: () => void;
    title: string;
  };
}

export const ChatCategory: FC<ChatCategoryProps> = ({ title, addNewConversation, chats }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <section css={sectionStyle} key={`chat-category-section-${title}`}>
      <div css={containerStyle}>
        <div css={chevronContainerStyle}>
          {!!chats.length && (
            // TODO: we are using a deprecated IconButton component, will be replacing it with the new one in future commits
            <IconButton
              size='xsmall'
              label=''
              onClick={() => setIsExpanded((prev) => !prev)}
              //   FIXME: add tracking id
              //   trackingId={trackingId({ component: 'tray', context: `expand-collapse-${title.toLowerCase()}` })}
            >
              <CaretDownIconSmall css={[caretStyle, isExpanded && caretTransition]} size={12} />
            </IconButton>
          )}
          <Text css={titleStyle}>{title}</Text>
        </div>
        {addNewConversation && (
          <IconButton label={addNewConversation.title} onClick={addNewConversation.onClick} size='small'>
            <PlusIcon size={16} css={css({ path: { fill: theme.colors.neutral90 } })} />
          </IconButton>
        )}
      </div>
      {isExpanded && chats.map((chat) => <ChatListItem chat={chat} key={`chat-list-item-${chat.channelId}`} />)}
      {addNewConversation && (
        <AddButton
          onClick={addNewConversation.onClick}
          title={addNewConversation.title}
          css={{ padding: theme.spacing(0.5), width: 'inherit' }}
        />
      )}
    </section>
  );
};
